module.exports = __webpack_public_path__ + "fonts/a879796816c437bf773eb9ad43374894.otf";